import React from "react";

export default function UserCard({ user_id }) {
	return (
		<div className="rounded-xl border border-gray-200 p-5">
			<p className="eyebrow text-[0.7rem] text-spruce-700">User</p>
			<p className="mt-1 text-xl font-bold tracking-tight text-ink">#{user_id}</p>
		</div>
	);
}
